import { styled } from '@mui/material';
import { Button } from "@mui/material";

export const StyledButton = styled(Button)`
  && {
    border: 1px solid #8c8c8c80;
    color: #8c8c8c;
    background-color: transparent;
  }
`;